<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="certificate_type_list" sort-by="name" class="elevation-1 mytable" dense
        :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Certificate Type</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row justify="center" dense>
            <v-col sm="3" md="8" cols="12"> </v-col>
            <v-col sm="6" md="6" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Certificate Type</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.name" persistent-hint :disabled="editedIndex != -1" :hint="
                              editedIndex == -1
                                ? 'For example :: Bonafide'
                                : 'noneditable'
                            " :filled="editedIndex == -1 ? false : true" label="Enter Certificate Type"
                            :rules="[(v) => !!v || 'required']">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.display_name" persistent-hint hint="For ex. Bonafide,..."
                            label="Enter Display Name for Certificate Type" :rules="[(v) => !!v || 'required']">
                          </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                        <!-- <v-col >
                    <v-hidden v-model="editedItem.divisionId" label="divisionId"></v-hidden>
                  </v-col>     -->
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
          <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import "@/assets/css/color.css";
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    valid: false,
    overlay: false,
    errorMsg: {
      name: false,
    },
    // extraBreadcrumbItems: [
    //   { text: "Certificate Type Master", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style2",
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Name",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Display Name",
        align: "left",
        sortable: false,
        value: "display_name",
      },
      {
        text: "Active",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    certificate_type_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      display_name: "",
      name: "",
      isactive: true,
    },
    defaultItem: {
      id: "",
      display_name: "",
      name: "",
      isactive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Certificate Type"
        : "Edit Certificate Type";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    initializeErrorMsgFalse() {
      this.errorMsg.name = false;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AdmissionMaster/certificate_type_home")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.certificate_type_list = res.data.certificate_type_list;
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          "use strict";
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.certificate_type_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/edit_certificate_type", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                Object.assign(
                  this.certificate_type_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar(
                  "#4caf50",
                  "Certificate Type Updated Successfully..."
                ); // show snackbar on success
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      } else {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/save_certificate_type", this.editedItem)
            .then((res) => {
              if (res.data.code == "SUCCESS") {
                this.certificate_type_list.push(this.editedItem);
                this.showSnackbar(
                  "#4caf50",
                  "Certificate Type Added Successfully..."
                ); // show snackbar on success
                this.onLoad();
              } else if (res.data.code == "NA") {
                this.showSnackbar(
                  "#b71c1c",
                  "Certificate Type Already Present!!!"
                ); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });

          this.close();
        }
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.name) {
        return true;
      } else {
        if (!this.editedItem.name) {
          this.errorMsg.name = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>